var MdaVerificationController, MdaVerificationView, ModuleController, mediator,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

ModuleController = require('controllers/base/module_controller');

MdaVerificationView = require('views/mda/mda_verification_view');

mediator = require('mediator');

module.exports = MdaVerificationController = (function(_super) {
  __extends(MdaVerificationController, _super);

  function MdaVerificationController() {
    return MdaVerificationController.__super__.constructor.apply(this, arguments);
  }

  MdaVerificationController.prototype.index = function() {
    return this.view = new MdaVerificationView;
  };

  return MdaVerificationController;

})(ModuleController);
